import {
	Box,
	Button,
	Center,
	Group,
	AppShell,
	useMantineTheme,
	Text,
	TextInput,
	Container,
	NativeSelect,
	Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { Avatar } from "@mantine/core";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { userInformation } from "../../services/Action/userAction";
import Headr from "../../components/Headr";
import ReactFlagsSelect from "react-flags-select";
import { IconChevronDown } from "@tabler/icons";
import { useState } from "react";
import ReactRoundedImage from "react-rounded-image";
import { useSelector } from "react-redux";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
import Footr from "../../components/Footr";
import { useEffect } from "react";
import { CDN_URL, LOCAL_URL } from "../../constant";
import updateUserProfile from "../../API/updateUserProfile";
import setUserProfile from "../../API/setUserProfile";
import axios from "axios";
function Profile() {
	let formData = new FormData();
	const user = useSelector((state) => state.userInformationReducer.users);
	const theme = useMantineTheme();
	const dispatch = useDispatch();
	const [selected, setSelected] = useState();
	const [uploadImage, setUploadImage] = useState();
	const [imageURL, setimageURL] = useState();
	const [loading, setLoading] = useState(false);
	const profileImageHandler = (event) => {
		let url = URL.createObjectURL(event.target.files[0]);
		setUploadImage(event.target.files[0]);
		setimageURL(url);
		formData.append("myfile", uploadImage);
	};
	const form = useForm({
		initialValues: {
			myfile: "",
			UserId: user.UserId,
			FirstName: user.FirstName,
			LastName: user.LastName,
			ZipCode: user.ZipCode,
			Country: user.Country,
			City: user.City,
			TimeZone: user.TimeZone,
			ContactNumber: user.ContactNumber,
			Address: user.Address,
		},
		validate: {
			FirstName: (value) =>
				value.length < 2 ? "Name must have at least 2 letters" : null,
			LastName: (value) =>
				value.length < 2 ? "Name must have at least 2 letters" : null,
		},
	});
	useEffect(() => {
		setSelected(user?.Country);
	}, []);

	const handleSubmit = async (value) => {
		formData.append("myfile", uploadImage);
		formData.append(
			"bodyData",
			JSON.stringify({
				UserId: user?.UserId,
				FirstName: value.FirstName,
				LastName: value.LastName,
				Address: value.Address,
				ZipCode: value.ZipCode,
				Country: selected,
				City: value.City,
				TimeZone: value.TimeZone,
				ContactNumber: value.ContactNumber,
			})
		);
		let result, userIdExist;
		try {
			userIdExist = await axios.get(
				`${LOCAL_URL}/addresses/${user?.UserId}`
			);
		} catch (err) {
			userIdExist = undefined;
		}
		let myfile = formData.get("myfile");
		if (userIdExist.data === user?.UserId && myfile !== undefined) {
			result = await updateUserProfile(formData, user?.UserId);
		} else {
			result = await setUserProfile(formData);
		}
		dispatch(await userInformation(user?.UserId));
		setLoading(false);
		if (result.msg === "success") {
			showSuccessNotification("update successfuly");
		} else {
			showErrorNotification("error");
		}
	};
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 100px)",
					maxHeight: "auto",
					borderTop: "none",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
			header={<Headr />}
		>
			<div className="signupForm">
				<ToastContainer />
				<Container size="xs" px="xs">
					<form
						onSubmit={form.onSubmit((value) => {
							setLoading(true);
							handleSubmit(value);
						})}
					>
						<Group position="center" mb={30} mt={5}>
							<Group
								style={{
									position: "relative",
								}}
							>
								{imageURL ? (
									<ReactRoundedImage
										imageWidth="100"
										imageHeight="100"
										roundedSize="0"
										image={imageURL}
									/>
								) : (
									<Avatar
										src={
											user?.userProfile &&
											CDN_URL + user?.userProfile
										}
										radius={100}
										size={100}
									/>
								)}
								<input
									style={{
										position: "absolute",
										left: "0",
										right: "0",
										top: "0",
										bottom: "0",
										cursor: "pointer",
										opacity: "0",
									}}
									type="file"
									accept=".jpg, .jpeg, .png"
									onChange={profileImageHandler}
								></input>
							</Group>
						</Group>
						<Text
							align="center"
							color="white"
							size="xl"
							weight={800}
							pb={10}
						>
							Update Profile
						</Text>
						<Text
							style={{ fontSize: "67%" }}
							align="center"
							color="white"
							size="xl"
							weight={100}
							pb={10}
						>
							You can update your Profile picture and Profile
							details here
						</Text>
						<Box sx={{ maxWidth: 340 }} mx="auto">
							<Center>
								<TextInput
									pr={10}
									required
									styles={{
										input: { backgroundColor: "#252E3D" },
										wrapper: { color: "#FFFFFF" },
										root: {
											width: "100%",
											color: "#FFFFFF",
										},
									}}
									{...form.getInputProps("FirstName")}
								/>
								<TextInput
									required
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "100%",
											color: "white",
										},
									}}
									{...form.getInputProps("LastName")}
								/>
							</Center>
							<Center className="inpMargin" mt={7}>
								<TextInput
									className="inpBackground"
									pr={10}
									required
									placeholder="Address"
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "100%",
											color: "white",
										},
									}}
									{...form.getInputProps("Address")}
								/>
								<TextInput
									required
									placeholder="Zipcode"
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "100%",
											color: "white",
										},
									}}
									{...form.getInputProps("ZipCode")}
								/>
							</Center>
							<Center className="centerClass inpMargin">
								<div
									style={{
										marginRight: "10px",
										padding: "0px",
										width: "48.5%",
									}}
								>
									<ReactFlagsSelect
										rightSection={
											<IconChevronDown size={14} />
										}
										rightSectionWidth={30}
										className="ReactFlagsSelect"
										selected={selected}
										data
										onSelect={(code) => setSelected(code)}
										{...form.getInputProps("Country")}
									/>
								</div>
								<NativeSelect
									placeholder={user?.City}
									selected={user?.City}
									data={[
										"Lahore",
										"Faisalabad",
										"Multan",
										"Karachi",
									]}
									styles={{
										input: {
											backgroundColor: "#252E3D",
										},
										root: {
											width: "50%",
											color: "white",
										},
									}}
									rightSection={<IconChevronDown size={10} />}
									rightSectionWidth={40}
									{...form.getInputProps("City")}
								/>
							</Center>
							<Center className="inpMargin" mt={7}>
								<div
									style={{
										marginRight: "10px",
										width: "58%",
									}}
								>
									<NativeSelect
										placeholder="Time Zone"
										data={[
											"GMT +5 (Islmabad) ",
											"GMT -5 (London)",
											"GMT -12 (Canada)",
										]}
										styles={{
											input: {
												backgroundColor: "#252E3D",
											},
											root: {
												width: "100%",
												color: "white",
											},
										}}
										rightSection={
											<IconChevronDown size={14} />
										}
										rightSectionWidth={40}
										{...form.getInputProps("Time Zone")}
									/>
								</div>
								<TextInput
									required
									type="tel"
									placeholder="Contact Number"
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "60%",
											color: "white",
										},
									}}
									{...form.getInputProps("ContactNumber")}
								/>
							</Center>
							<Group position="center" mt="md">
								<Button
									style={{ width: "170px" }}
									type="submit"
								>
									Update
								</Button>
							</Group>
						</Box>
					</form>
				</Container>
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default Profile;
